import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M13.962 16.296a6.716 6.716 0 01-3.462.954 6.728 6.728 0 01-4.773-1.977A6.728 6.728 0 013.75 10.5c0-1.864.755-3.551 1.977-4.773A6.728 6.728 0 0110.5 3.75a6.73 6.73 0 014.774 1.977A6.735 6.735 0 0117.25 10.5a6.717 6.717 0 01-.922 3.407c-.516.882-.433 1.988.29 2.711l3.854 3.853M7.5 10.5h6"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M13.962 16.296a6.716 6.716 0 01-3.462.954 6.728 6.728 0 01-4.773-1.977A6.728 6.728 0 013.75 10.5c0-1.864.755-3.551 1.977-4.773A6.728 6.728 0 0110.5 3.75a6.73 6.73 0 014.774 1.977A6.735 6.735 0 0117.25 10.5a6.717 6.717 0 01-.922 3.407c-.516.882-.433 1.988.29 2.711l3.854 3.853M7.5 10.5h6"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M27.924 32.592A13.432 13.432 0 0121 34.5c-3.728 0-7.102-1.51-9.546-3.954A13.455 13.455 0 017.5 21c0-3.728 1.51-7.102 3.954-9.546A13.455 13.455 0 0121 7.5a13.46 13.46 0 019.548 3.954A13.47 13.47 0 0134.5 21c0 2.486-.672 4.814-1.844 6.814-1.032 1.764-.866 3.976.58 5.422l7.708 7.706M15 21h12"
  }))
};
export var Zoomout = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});